import { render, staticRenderFns } from "./Destaque.vue?vue&type=template&id=e162e316&"
import script from "./Destaque.vue?vue&type=script&lang=js&"
export * from "./Destaque.vue?vue&type=script&lang=js&"
import style0 from "./Destaque.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports